import './styles.scss';

export default {
    name: 'MessagingMenu',

    computed: {
        disable_group_types() {
            if ('/action/emergency-messages/group-types' === this.$route.path) {
                return false;
            } else {
                return this.$store.state.messaging.group_types.length ? false : true;
            }
        },

        disable_floors() {
            if ('/action/emergency-messages/floors' === this.$route.path) {
                return false;
            } else {
                if (this.$store.state.messaging.notification_types.length) {
                    return false;
                } else {
                    return !this.$store.state.messaging.floors.length;
                }

            }
        },

        disable_notification_types() {
            if ('/action/emergency-messages/notification-types' === this.$route.path) {
                return false;
            } else {
                return this.$store.state.messaging.notification_types.length ? false : true;
            }
        },

        disable_message_type() {
            if ('/action/emergency-messages/choose-message' === this.$route.path) {
                return false;
            } else {
                return this.$store.state.messaging.message_type ? false : true;
            }
        },

        disable_available_messages() {
            if ('/action/emergency-messages/available-messages' === this.$route.path) {
                return false;
            } else {
                return this.$store.state.messaging.message_type !== 'new' ? false : true;
            }
        },

        disable_message() {
            if ('/action/emergency-messages/compose-message' === this.$route.path || '/action/emergency-messages/preview' === this.$route.path) {
                return false;
            } else {
                return this.$store.state.messaging.message ? false : true;
            }
        }
    }
};